import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Product } from '../component/pages/dashboard/product.store';

@Injectable({ providedIn: 'root' })
export class ProductsService {
  constructor(private httpClient: HttpClient) {}

  public getProduct(
    categoryId: number,
    metaCategory: number,
    page: number,
    filter: 'deebr' | 'new' | 'visuel' | 'promo' | null,
    sort: { key: 'stock' | 'ventes' | 'pageviews' | 'score' | null; direction: 'ASC' | 'DESC' },
    searchTerm?: string | null,
    exclude_ids?: string | null,
    list_images_url?: string | null,
    startat?: string | null,
    startatComparator?: string | null,
    endat?: string | null,
    endatComparator?: string | null,
    stockMin?: number | null,
    stockMax?: number | null,
    export_value: boolean = false,
    responseType: 'json' | 'blob' = 'json',
  ): Observable<any> {
    let params = new HttpParams()
      .set('category', categoryId.toString())
      .set('meta_category', metaCategory.toString())
      .set('page', page.toString());

    if (filter != null) {
      params = params.set('filter', filter);
    }
    if (sort && sort.key) {
      params = params.set('tri', sort.key).set('ordre', sort.direction);
    }
    if (searchTerm != null) {
      params = params.set('search', searchTerm);
    }
    if (export_value) {
      params = params.set('export', export_value.toString());
    }
    if (exclude_ids != null) {
      params = params.set('exclude_ids', exclude_ids);
    }
    if (list_images_url != null) {
      params = params.set('list_images_url', list_images_url);
    }
    if (startat != null && startatComparator != null) {
      params = params.set('startat', startat).set('startat_comparator', startatComparator);
    }
    if (endat != null && endatComparator != null) {
      params = params.set('endat', endat).set('endat_comparator', endatComparator);
    }

    // Only add when defined (null/undefined are skipped). 0 is allowed.
    if (stockMin != null) {
      params = params.set('stock_min', String(stockMin));
    }
    if (stockMax != null) {
      params = params.set('stock_max', String(stockMax));
    }

    return this.httpClient.get<Product[]>(`${environment.backendUrl}/api/products`, {
      params,
      // keep your current typing approach
      responseType: responseType as 'json'
    });
  }
}


